import * as React from 'react';
import Grid from '@mui/material/Grid';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CustomModal from '../../Common/CustomModal';
import StyledBackButton from '../../Common/StyledBackButton';
import StyledButton from '../../Common/StyledButton';

interface IRecordingDisclaimerProps {
  handleOnClickLeft: () => void;
  handleOnClickRight: () => void;
  content: React.ReactNode;
  btnTextLeft: string;
  btnTextRight: string;
  open: boolean;
  btnLeftLoading?: boolean;
  btnRightLoading?: boolean;
  md?: number;
}

const RecordingDisclaimerModal = ({
  handleOnClickLeft,
  handleOnClickRight,
  content,
  btnTextLeft,
  btnTextRight,
  open,
  btnLeftLoading,
  btnRightLoading,
  md = 4.5,
}: IRecordingDisclaimerProps) => {
  const { t } = useTranslation();

  return (
    <CustomModal isOpen={open} xs={8} md={6} lg={md}>
      <Grid container>
        <Grid
          item
          textAlign="center"
          sx={{
            background: `linear-gradient(175.46deg, rgba(255, 228, 159, 0.2) -9.81%,rgba(254, 178, 30, 0.2) 96.32%);`,
            borderTopLeftRadius: '10px',
            borderTopRightRadius: '10px',
          }}
          width="100%"
          display="flex"
          flexDirection="column"
          gap="11px"
          px={0}
          py={4}
        >
          <Box component="img" height={56} src="/assets/icons/shield-warning.svg" />
          <Typography variant="title2Bold" color="primary.main">
            {t('common.disclaimer')}
          </Typography>
        </Grid>
        <Grid item p={4} pt="48px" xs={12}>
          <Typography color="primary" textAlign="center">
            {content}
          </Typography>
          <Grid container pt="48px" justifyContent="space-between" xs={12}>
            {!btnLeftLoading ? (
              <Grid item xs={5.5}>
                <StyledBackButton
                  onClick={handleOnClickLeft}
                  disabled={btnRightLoading}
                  fullWidth
                  sx={{ height: 48 }}
                >
                  <span>{btnTextLeft}</span>
                </StyledBackButton>
              </Grid>
            ) : (
              <Grid item xs={5.5} height={48}>
                <StyledButton
                  onClick={handleOnClickRight}
                  loading={btnLeftLoading}
                  fullWidth
                  paddingY={14}
                >
                  {btnTextLeft}
                </StyledButton>
              </Grid>
            )}
            <Grid item xs={5.5} height={48}>
              <StyledButton
                onClick={handleOnClickRight}
                loading={btnRightLoading}
                disabled={btnLeftLoading}
                fullWidth
                paddingY={14}
              >
                {btnTextRight}
              </StyledButton>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </CustomModal>
  );
};

export default RecordingDisclaimerModal;
